import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarView.css';

const CalendarView = ({ board, allCards, onCardClick }) => {
  const [value, onChange] = useState(new Date());

  const getCardsForDate = (date) => {
    const dateString = date.toISOString().split('T')[0];
    return allCards.filter(card => {
      if (!card.dueDate) return false;
      return new Date(card.dueDate).toISOString().split('T')[0] === dateString;
    });
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const cards = getCardsForDate(date);
      if (cards.length > 0) {
        return (
          <div className="flex flex-col mt-1 space-y-0.5">
            {cards.slice(0, 3).map(card => (
              <div 
                key={card._id}
                onClick={(e) => { e.stopPropagation(); onCardClick(card._id); }}
                className="text-[8px] bg-primary-blue text-white px-1 rounded truncate shadow-sm cursor-pointer hover:bg-blue-700"
              >
                {card.title}
              </div>
            ))}
            {cards.length > 3 && <div className="text-[8px] text-gray-400 dark:text-gray-500 font-bold">+{cards.length - 3} more</div>}
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-white/50 dark:border-gray-700/50 p-6 flex-1 flex flex-col items-center">
      <div className="w-full max-w-4xl calendar-container h-full overflow-y-auto">
        <Calendar 
          onChange={onChange} 
          value={value} 
          tileContent={tileContent}
          calendarType="gregory"
          className="w-full border-none shadow-none rounded-lg"
        />
      </div>
    </div>
  );
};

export default CalendarView;